/* Partner referral rail: a visitor who arrives on a partner link (/r/<code> redirects to /?ref=<code>)
   is remembered for 90 days, sees a slim "Referred by" bar, and every cart they build carries the partner
   as cart attributes (rt_partner_code, rt_partner, rt_partner_date), which land on the order.
   The partner names come from the JSON the rt-partner-ref snippet prints (active partners only).
   Nothing here depends on analytics consent: the visitor brought the code with them. */
(function () {
  "use strict";
  var KEY = "rt_partner", DAYS = 90;

  function load() { try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch (e) { return null; } }
  function store(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function partners() {
    try { var el = document.getElementById("rt-partners"); return el ? JSON.parse(el.textContent || "{}") : {}; } catch (e) { return {}; }
  }
  function clean(code) { return String(code || "").toLowerCase().replace(/[^a-z0-9-]/g, "").slice(0, 40); }

  function capture() {
    var q = new URLSearchParams(window.location.search);
    var code = clean(q.get("ref"));
    if (!code) return load();
    var p = partners()[code];
    if (!p) return load();                       // unknown or paused code: nothing changes
    var rec = { code: code, name: p.name || code, date: new Date().toISOString().slice(0, 10) };
    store(rec);
    return rec;
  }
  function fresh(r) { return !!(r && r.code && r.date && (Date.now() - new Date(r.date).getTime()) < DAYS * 864e5); }

  function showBar(r) {
    var bar = document.querySelector("[data-rt-partner-bar]");
    if (!bar) return;
    var n = bar.querySelector("[data-rt-partner-name]");
    if (n) n.textContent = r.name;
    bar.hidden = false;
  }

  function stamp(r) {
    if (!window.fetch) return;
    fetch("/cart.js", { credentials: "same-origin" }).then(function (x) { return x.json(); }).then(function (cart) {
      var have = (cart && cart.attributes) || {};
      if (have.rt_partner_code === r.code) return;
      return fetch("/cart/update.js", {
        method: "POST", credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ attributes: { rt_partner_code: r.code, rt_partner: r.name, rt_partner_date: r.date } })
      });
    }).catch(function () {});
  }

  // Re-stamp after every cart add, the same way rt-events.js re-syncs its touches.
  function watchCartAdds(r) {
    if (!window.fetch) return;
    var orig = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      var p = orig.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) p.then(function (res) { if (res && res.ok) setTimeout(function () { stamp(r); }, 80); }).catch(function () {});
      return p;
    };
  }

  function start() {
    var landed = !!clean(new URLSearchParams(window.location.search).get("ref"));
    var r = capture();
    if (!fresh(r)) return;
    showBar(r);
    stamp(r);
    watchCartAdds(r);
    if (landed && typeof window.rtTrack === "function") window.rtTrack("rt_partner_referral_landing", { partner_code: r.code });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
})();
